// Component: TopicPanel
// Author: Mito Are
import React from 'react';
import { Text, RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import TopicCard from '@component/TopicCard';
import WBRString from '@component/WbrString';
import { RoutableLink } from '../../react/RoutableLink';

const TopicCardComponent = (props) => {
  return (
    <>
      {props.fields && (
        <TopicCard
          subTitle={
            <RoutableLink field={props.fields?.link} useATag={true}>
              <WBRString tag="span">
                <Text field={props.fields?.title} />
              </WBRString>
            </RoutableLink>
          }
          text={<RichText field={props.fields?.copy} />}
        />
      )}
    </>
  );
};
export default withSitecoreContext()(TopicCardComponent);
